module.exports = __webpack_public_path__ + "img/admin-banners.dd4fa07c.svg";